import { DefaultError, useMutation } from "@tanstack/react-query";
import { PageModuleData } from "entities/pages/types";
import { bulkUpdateModulesByBrandSetting } from "../api/bulkUpdateModulesByBrandSetting";
import { setModuleListByBranchSettingQueryData } from "../queries/useModuleListByBrandSettingQuery";

type Params = {
  brandId: string;
  settingId: string;
  modules: PageModuleData[];
};

export const useReorderSettingModulesMutation = () => {
  return useMutation<void, DefaultError, Params>({
    mutationFn: async (variables) => {
      const dataToUpdate = variables.modules.reduce((acc, module) => {
        return {
          ...acc,
          [module.id]: { order: module.order },
        };
      }, {});

      setModuleListByBranchSettingQueryData(
        variables.brandId,
        variables.settingId,
        variables.modules,
      );

      await bulkUpdateModulesByBrandSetting(
        variables.brandId,
        variables.settingId,
        dataToUpdate,
      );
    },
  });
};
